import request from '@/utils/request'
import gateway from '@/_gateway.config.js'

let { parent } = gateway

// 根据班主任ID获取班主任详情
export function getMasterInfo (params) {
  return request({
    url: `${parent}/api/wx/class/master`,
    method: 'GET',
    params
  })
}
